import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";

import theme from "config/theme";

import Layout from "components/Layout";
import { HeroFeature } from "components/Hero";
import { Container } from "components/Grid";
import { ActionBlock, VideoBlock } from "components/Block";
import SubscribeForm from "components/SubscribeForm";

import Overview from "./Overview";
import Text from "./Text";
import Process from "./Process";
import ContentVideoBlock from "./ContentVideoBlock";
import Benefits from "./Benefits";
import Values from "./Values";
import Jobs from "./Jobs";

export const CareersPageTemplate = ({ page }) => {
  return (
    <>
      <HeroFeature content={page.hero} shade="light" />
      <Overview content={page.block1} />
      <Process content={page.process} />
      <Text content={page.block2} />
      <Benefits content={page.benefits} />
      <Values content={page.values} />
      <Container pt="90px" bg={theme.color.paper} flexDirection="column">
        <Jobs content={page.jobs} />
        <ActionBlock content={page.cta}>
          <SubscribeForm m="40px auto 0" maxWidth="500px" />
        </ActionBlock>
      </Container>
    </>
  );
};

// CareersPageTemplate.propTypes = {
//   title: PropTypes.string
// };

const CareersPage = ({ data }) => {
  const { frontmatter: page } = data.markdownRemark;
  return (
    <Layout page={page} shade="paper">
      <CareersPageTemplate page={page} />
    </Layout>
  );
};

CareersPage.propTypes = {
  data: PropTypes.object.isRequired
};

export default CareersPage;

export const careersPageQuery = graphql`
  query CareersPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        page {
          title
        }
        hero {
          heading
          subheading
          buttonText
          buttonPath
        }
        block1 {
          title
          heading
          text
          image {
            childImageSharp {
              fluid(maxWidth: 800, quality: 100) {
                ...GatsbyImageSharpFluid_noBase64
              }
            }
          }
          features {
            heading
            text
            icon {
              relativePath
            }
          }
        }
        process {
          title
          heading
          subheading
          buttonText
          buttonPath
          steps {
            title
            summary
            icon {
              relativePath
            }
            items {
              title
              text
            }
          }
        }
        block2 {
          title
          heading
          text
        }
        benefits {
          heading
          subheading
          items {
            icon {
              relativePath
            }
            text
          }
        }
        values {
          heading
          subheading
          items {
            icon {
              relativePath
            }
            text
          }
        }
        jobs {
          heading
          subheading
          departments {
            name
            description
          }
        }
        cta {
          heading
          subheading
          buttonText
          buttonPath
        }
      }
    }
  }
`;
